<template>
    <div id="app">
        <v-app id="inspire">
            <v-card v-model="show" color="#FFFF99">
                <v-card-title>
                    <v-icon large left>mdi-wrench-clock</v-icon>
                    <h6>Obligaciones Periódicas RRHH</h6>
                </v-card-title>
            </v-card>

            <v-data-table dense :headers="headers" :items="listado" locale="es-ar" class="elevation-1"
                :items-per-page="200">
                <template v-slot:item.fecha="{ item }">
                    <v-chip :color="getColor(item.fecha)">
                        {{ item.fecha }}
                    </v-chip>
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon small color="blue" class="mr-2" v-on="on" v-bind="attrs"
                                @click.stop="verPlanilla(item)">
                                mdi-eye
                            </v-icon>
                        </template>
                        <span>ver plan</span>
                    </v-tooltip>
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon small color="purple" class="mr-2" v-on="on" v-bind="attrs"
                                @click.stop="editarPlanilla(item)">
                                mdi-pencil
                            </v-icon>
                        </template>
                        <span>editar plan</span>
                    </v-tooltip>
                </template>
            </v-data-table>
            <VerPlanilla :visible="showPlanilla" :codgral="editedItem.codgral" :descr="editedItem.descr"
                @close="showPlanilla = false">
            </VerPlanilla>
            <EditarPlanilla :visible="showEditar" :codgral="editedItem.codgral" :descr="editedItem.descr"
                :entidad="editedItem.entidad" :frecuencia="editedItem.frecuencia" @close="showEditar = false">
            </EditarPlanilla>
        </v-app>
    </div>
</template>

<script>
import moment from "moment";
import axios from "../../../axios-auth";
import VerPlanilla from "../Obligaciones/Listadohistorial.vue";
import EditarPlanilla from "../Obligaciones/Editar.vue";
import jsPDF from "jspdf";
import "jspdf-autotable";
export default {
    components: { VerPlanilla, EditarPlanilla },
    //components: { VerPlanilla },
    data: (vm) => ({
        editedItem: {},
        editedIndex: -1,
        listado: [],
        showPlanilla: false,
        showEditar: false,

        headers: [
            {
                text: "Pago",
                align: "center",
                sortable: false,
                value: "descr",
            },
            { text: "Monto", value: "monto", sortable: false },
            { text: "Entidad", value: "entidad", sortable: false },
            { text: "Fecha Último Pago", value: "fechault", sortable: false },
            { text: "Fecha Próximo Pago", value: "fecha", sortable: false },
            { text: "Frecuencia", value: "frecuencia", sortable: false },
            { text: "Acciones", value: "actions", align: "center", sortable: false },
        ],
    }),

    computed: {
        show: {
            get() {
                this.cargarListados();
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },

    methods: {

        getColor(fecha) {
            var Hoy = moment().format("DD/MM/YYYY");
            if (
                moment(fecha, "DD/MM/YYYY")
                    .fromNow()
                    .includes("ago")
            )
                return "red";
            else
                return "green";
        },

        cargarListados() {
            this.vaciarModels();
            let self = this;

            axios
                .get("/RRHH/ListadoObligacionesRRHH?", {
                })
                .then((response) => {
                    self.listado = response.data;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        verPlanilla(item) {
            this.editedIndex = this.listado.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.showPlanilla = true;
        },
        editarPlanilla(item) {
            this.editedIndex = this.listado.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.showEditar = true;
        },

        vaciarModels() {
            this.listado = [];
        },
    },
};
</script>